import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Header from "../../Templates/Header";
import { devicesRegistry } from "./data/deviceRegistrationSteps";
import { usePanelTokens } from "../../../utils/panelTokens";

const DeviceCard = ({ device, onClick }) => {
  const T = usePanelTokens();
  const [hovered, setHovered] = React.useState(false);
  const [imgError, setImgError] = React.useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: T.ground,
        border: `1px solid ${hovered ? T.accent : T.border}`,
        borderRadius: "10px",
        overflow: "hidden",
        cursor: "pointer",
        transition: "border-color 0.2s, box-shadow 0.2s, transform 0.2s",
        transform: hovered ? "translateY(-3px)" : "none",
        boxShadow: hovered
          ? "0 0 0 1px rgba(58,142,255,0.35), 0 8px 28px rgba(58,142,255,0.12)"
          : "none",
      }}
    >
      {/* Image area */}
      <div
        style={{
          height: "180px",
          background: T.surface,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!imgError ? (
          <img
            src={device.image}
            alt={device.name}
            onError={() => setImgError(true)}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              transform: hovered ? "scale(1.04)" : "scale(1)",
              transition: "transform 0.35s ease",
            }}
          />
        ) : (
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background: "rgba(58,142,255,0.08)",
              border: "1px solid rgba(58,142,255,0.15)",
            }}
          />
        )}
        {/* Bottom gradient */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "70px",
            background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
          }}
        />
      </div>

      {/* Card body */}
      <div style={{ padding: "16px 18px 18px", borderTop: `1px solid ${T.borderSoft}` }}>
        <p
          style={{
            margin: 0,
            fontSize: "15px",
            fontWeight: 700,
            color: T.text,
            letterSpacing: "0.06em",
          }}
        >
          {device.name}
        </p>
        <p
          style={{
            margin: "6px 0 14px",
            fontSize: "12px",
            color: T.textMuted,
            fontStyle: "italic",
            lineHeight: 1.5,
          }}
        >
          {device.tagline}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontSize: "12px",
            color: T.accent,
            fontWeight: 500,
          }}
        >
          View Documentation
          <ArrowForwardIcon style={{ fontSize: "13px" }} />
        </div>
      </div>
    </div>
  );
};

const DocsList = ({ onSelectDevice }) => {
  const T = usePanelTokens();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        background: T.ground,
        color: T.text,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      {/* ── HEADER (same as all other pages) ── */}
      <Header
        title="Documentation"
        subtitle="Step-by-step guides, API references, and tutorials for the VECROS platform."
      />

      {/* ── CONTENT ── */}
      <div style={{ flex: 1, padding: "32px 40px" }}>
        {/* Section heading */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginBottom: "24px",
          }}
        >
          <span
            style={{
              fontSize: "11px",
              fontWeight: 700,
              color: T.textMuted,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            Devices
          </span>
          <div style={{ flex: 1, height: "1px", background: T.border }} />
        </div>

        {/* Device cards grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
          }}
        >
          {devicesRegistry.map((device) => (
            <DeviceCard
              key={device.id}
              device={device}
              onClick={() => onSelectDevice(device.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocsList;
